import barcraftIcon from '@/assets/app-icons/barcraft.png';
import gambaIcon from '@/assets/app-icons/gamba.png';
import mtgcraftIcon from '@/assets/app-icons/mtgcraft.png';
import napakIcon from '@/assets/app-icons/napak.png';

export interface LauncherApp {
  /** Stable catalog id used as the config key. Never change once shipped. */
  id: string;
  /** Short display name shown under the icon. */
  name: string;
  /** Public https URL opened in a new tab. */
  url: string;
  /** Imported asset URL (hashed by Vite at build time). Omit to render a color+initial fallback. */
  icon?: string;
}

/**
 * Hardcoded catalog of launchable personal apps. The order here is the render
 * order. URLs are public https endpoints — no secrets. Config only toggles
 * which of these are visible; the catalog itself is not user-editable in v1.
 */
export const APP_CATALOG: readonly LauncherApp[] = [
  { id: 'mtgcraft', name: 'MtgCraft', url: 'https://mtgcraft.jums.fi/', icon: mtgcraftIcon },
  { id: 'barcraft', name: 'BarCraft', url: 'https://barcraft.jums.fi/', icon: barcraftIcon },
  { id: 'napak', name: 'Napak', url: 'https://app.napak.fi/', icon: napakIcon },
  { id: 'gamba', name: 'Gamba', url: 'https://gamba-calendar.web.app/', icon: gambaIcon },
];
